import React, { useState, useEffect } from 'react';

import { dataGridPremiumColumns, getIcon } from '../../utils/helper';
import { DataGridIdentifiers, DatagridPremiumUi, OrderArrowsUI } from '../Interface';
import favouriteMenuService from '../../service/favouriteMenu.service';

export const FavouriteMenusReports = ({
  refetch,
  values,
  viewField,
  operatorsDisabled,
  rowSelection,
  user,
  menuData,
  setFavouriteMenu,
}) => {
  const { refetchTable, setRefetchTable } = refetch;
  const { setSelectedValues } = values;
  const { rowSelectionModel, setRowSelectionModel } = rowSelection;

  const [orderChanged, setOrderChanged] = useState(false);
  const [reports, setReports] = useState({ rows: [], rowCount: 0 });

  const initialState = {
    filter: {
      filterModel: { items: [], logicOperator: 'and' },
    },
    sorting: {
      sortModel: [{ field: 'name', sort: 'asc' }],
    },
    pagination: {
      paginationModel: {
        pageSize: 25,
        page: 0,
      },
    },
    density: 'compact',
  };

  useEffect(() => {
    if (operatorsDisabled) {
      setRowSelectionModel([]);
    }
  }, [operatorsDisabled]);

  const getList = (gridState) => {
    const stateWithUserFilter = {
      ...gridState,
      filter: {
        ...gridState.filter,
        filterModel: {
          ...gridState.filter?.filterModel,
          items: [
            ...(gridState.filter?.filterModel?.items || []),
            { field: 'createdBy', value: user?.userId, operator: 'and' },
          ],
          logicOperator: 'and',
        },
      },
    };

    favouriteMenuService.getRows(stateWithUserFilter).then((data) => {
      setReports(data);
      if (orderChanged) {
        setFavouriteMenu(data.rows);
        setOrderChanged(false);
      }
    });
  };

  const orderData = (id, newOrder) => {
    favouriteMenuService.orderData(id, { newOrder }).then((data) => {
      setRefetchTable(true);
      setOrderChanged(true);
    });
  };

  const handleOrderChange = (id, direction) => {
    orderData(id, direction);
  };

  const columns = dataGridPremiumColumns([
    {
      field: 'subMenuUrl',
      headerName: 'Felület',
      type: 'string',
      filterable: false,
      valueGetter: (_, params) => {
        return menuData.find((menu) => menu.value === params.subMenuUrl)?.label;
      },
    },
    {
      field: 'name',
      headerName: 'Megnevezés',
      type: 'string',
    },
    {
      field: 'icon',
      headerName: 'Ikon',
      type: 'string',
      sortable: false,
      filterable: false,
      renderCell: (data) => {
        return getIcon(data.row.icon, '1.7rem');
      },
    },
    {
      field: 'showOnHomePage',
      headerName: 'Kezdőképernyő megjelenés',
      type: 'boolean',
    },
    {
      field: 'showOnNavbar',
      headerName: 'Fejléc megjelenés',
      type: 'boolean',
    },
    {
      field: 'visOrder',
      headerName: 'Sorrend',
      type: 'action',
      renderCell: (params) => {
        const disabled = params?.api?.getSortModel()[0]?.field !== 'visOrder';
        const isSortedDescending = params.api.getSortModel()[0]?.sort === 'desc';

        const handleUpClick = () => {
          if (isSortedDescending) {
            handleOrderChange(params.row.id, 'down');
          } else {
            handleOrderChange(params.row.id, 'up');
          }
        };

        const handleDownClick = () => {
          if (isSortedDescending) {
            handleOrderChange(params.row.id, 'up');
          } else {
            handleOrderChange(params.row.id, 'down');
          }
        };

        return <OrderArrowsUI onUpClick={handleUpClick} onDownClick={handleDownClick} disabled={disabled} />;
      },
    },
  ]);

  return (
    <DatagridPremiumUi
      datagridIdentifier={DataGridIdentifiers.favouriteMenu}
      datagridInitialState={initialState}
      dataLoader={user?.userId && getList}
      rows={reports.rows}
      refetch={{ refetchTable, setRefetchTable }}
      rowCount={reports.rowCount}
      columns={[...columns]}
      onRowClick={(rowData) => {
        if (!viewField) return;
        setSelectedValues(rowData.row);
      }}
      paginationAndfilterMode="server"
      onRowSelectionModelChange={(newRowSelectionModel) => {
        setRowSelectionModel(newRowSelectionModel);
      }}
      rowSelectionModel={rowSelectionModel}
      disableRowSelectionOnClick={!viewField}
    />
  );
};
